import React from 'react';
import PropTypes from 'prop-types';

import cn from './style.module.scss';

export function Option(props) {
  const className = [cn.optionListItem, props.className].join(' ');
  return (
    <li onClick={props.onClick} className={className}>
      {props.children}
    </li>
  );
}

Option.propTypes = {
  /**
   * className
   */
  className: PropTypes.string,
  /**
   * child components
   */
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]),
  /**
   * onClick
   */
  onClick: PropTypes.func,
};

Option.defaultProps = {
  className: '',
};
